export default __webpack_public_path__ + "static/media/mapping-confirmation.b103b351.svg";